/** @var Максимальный размер файла при единичной загрузке*/
export const SINGLE_FILE_SIZE_LIMIT = 15728640;

/** @var Максимальный размер файлов при множественной загрузке */
export const MULTIPLE_FILES_SIZE_LIMIT = 41943040;

/** @var Разрешенные типы файлов при множественной загрузке*/
export const FILE_TYPES = ['jpg', 'jpeg', 'png', 'gif', 'pdf'];
export const FILE_TYPES_ONLY_IMG = ['jpg', 'jpeg', 'png'];
